var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPcaGraphic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 331,
    height: 227,
    viewBox: "0 0 331 227",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_306",
    "data-name": "Rectangle 306",
    width: 331,
    height: 227,
    fill: "#1e1e2d"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_252",
    "data-name": "Rectangle 252",
    width: 127,
    height: 34,
    transform: "translate(0.026 0.418)",
    fill: "#8eeff4",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_253",
    "data-name": "Rectangle 253",
    width: 160,
    height: 35,
    transform: "translate(0.026 -0.134)",
    fill: "#8eeff4",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_589",
    "data-name": "Group 589",
    transform: "translate(-5582 6619)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_95",
    "data-name": "Mask Group 95",
    transform: "translate(5582 -6619)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M629.573,468.859c-240.613,0-408.03,639.983-408.03,639.983H0V0H221.752V581.442C292.907,410.32,453.663,247.9,629.782,247.9s338.373,162.379,409.4,335.376V.042h221.543v1108.8H1039.1S870.061,468.859,629.573,468.859Z",
    transform: "translate(-235.769 857.365) rotate(-90)",
    fill: "#3a77f6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_481",
    "data-name": "Group 481",
    transform: "translate(5140.974 -7100.418)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_87",
    "data-name": "Mask Group 87",
    transform: "translate(531 530)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_144",
    "data-name": "Group 144",
    transform: "translate(0.232 -0.476)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M258.666,34.5c0-5.381-2.837-11.8-7.795-13.738a9.2,9.2,0,0,0,7.4-9.433c0-6.228-4.3-10.621-10.912-10.621H232V34.5h6.758v-12.5a12.535,12.535,0,0,1,13.094,12.5ZM246.874,15.524h-8.112V7.174h8.112c2.845,0,4.634,1.5,4.634,4.15S249.718,15.524,246.874,15.524ZM228.72,34.5,214.962.7h-8.013L193.289,34.5h7.4c2.557-5.73,9.726-8.755,16.841-9.4l3.771,9.4ZM205.627,22.119,210.98,8.768l4.038,10.069a28.41,28.41,0,0,0-9.39,3.284ZM82.214.7v19.8C78.087,13.351,70.059,4.436,66.734.7H58.7V34.5h6.754V9.173c5.034,5.338,13.5,18.265,16.437,25.324h7.075V.7Zm-63.028,19.5C11.854,20.208,6.752.7,6.752.7H0V34.5H6.758V16.777c2.169,5.215,7.068,10.165,12.435,10.165S29.505,21.994,31.67,16.722V34.5h6.752V.7H31.667s-5.152,19.5-12.481,19.5ZM45.232.7H51.99V34.5H45.232ZM95.775.7h13.034c9.6,0,16.172,7.486,16.172,16.943S118.412,34.5,108.809,34.5H95.775ZM108.71,27.691c5.409,0,9.272-4.2,9.272-10.043S114.119,7.509,108.71,7.509h-6.177V27.685ZM264.254.7h24.185V7.176H271.025v6.806h15.432v6.471H271.025v7.578h17.414V34.5H264.254ZM142.843,13.351c-4.634-.482-5.936-1.638-5.936-3.668,0-1.883,2.219-3.166,5.5-3.166a6.452,6.452,0,0,1,5.983,4.4l6.332-2.792C152.929,3.188,148.3,0,142.4,0,135.3,0,130.13,3.908,130.13,9.559c0,6.276,4.06,9.75,11.927,10.522,5.258.53,7.337,1.978,7.337,4.1,0,2.75-2.374,4.586-6.565,4.586-3.917,0-6.725-2.267-7.965-6.485l-6.271,2.421c1.737,6.525,6.893,10.532,14.246,10.532,8.108,0,13.323-4.586,13.323-11.25,0-6.549-4.729-9.765-13.319-10.636ZM190.054.7h-6.772V18.511c-3.007-3.035-7.7-4.578-15.4-4.578V.7H161.14V34.5H167.9v-14c7.7,0,15.5,2.058,15.5,14h6.651Z",
    transform: "translate(0 0.001)",
    fill: "#8eeff4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_88",
    "data-name": "Mask Group 88",
    transform: "translate(498 626.552)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_480",
    "data-name": "Group 480",
    transform: "translate(-128.453 -0.075)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M258.666,34.5c0-5.381-2.837-11.8-7.795-13.738a9.2,9.2,0,0,0,7.4-9.433c0-6.228-4.3-10.621-10.912-10.621H232V34.5h6.758v-12.5a12.535,12.535,0,0,1,13.094,12.5ZM246.874,15.524h-8.112V7.174h8.112c2.845,0,4.634,1.5,4.634,4.15S249.718,15.524,246.874,15.524ZM228.72,34.5,214.962.7h-8.013L193.289,34.5h7.4c2.557-5.73,9.726-8.755,16.841-9.4l3.771,9.4ZM205.627,22.119,210.98,8.768l4.038,10.069a28.41,28.41,0,0,0-9.39,3.284ZM82.214.7v19.8C78.087,13.351,70.059,4.436,66.734.7H58.7V34.5h6.754V9.173c5.034,5.338,13.5,18.265,16.437,25.324h7.075V.7Zm-63.028,19.5C11.854,20.208,6.752.7,6.752.7H0V34.5H6.758V16.777c2.169,5.215,7.068,10.165,12.435,10.165S29.505,21.994,31.67,16.722V34.5h6.752V.7H31.667s-5.152,19.5-12.481,19.5ZM45.232.7H51.99V34.5H45.232ZM95.775.7h13.034c9.6,0,16.172,7.486,16.172,16.943S118.412,34.5,108.809,34.5H95.775ZM108.71,27.691c5.409,0,9.272-4.2,9.272-10.043S114.119,7.509,108.71,7.509h-6.177V27.685ZM264.254.7h24.185V7.176H271.025v6.806h15.432v6.471H271.025v7.578h17.414V34.5H264.254ZM142.843,13.351c-4.634-.482-5.936-1.638-5.936-3.668,0-1.883,2.219-3.166,5.5-3.166a6.452,6.452,0,0,1,5.983,4.4l6.332-2.792C152.929,3.188,148.3,0,142.4,0,135.3,0,130.13,3.908,130.13,9.559c0,6.276,4.06,9.75,11.927,10.522,5.258.53,7.337,1.978,7.337,4.1,0,2.75-2.374,4.586-6.565,4.586-3.917,0-6.725-2.267-7.965-6.485l-6.271,2.421c1.737,6.525,6.893,10.532,14.246,10.532,8.108,0,13.323-4.586,13.323-11.25,0-6.549-4.729-9.765-13.319-10.636ZM190.054.7h-6.772V18.511c-3.007-3.035-7.7-4.578-15.4-4.578V.7H161.14V34.5H167.9v-14c7.7,0,15.5,2.058,15.5,14h6.651Z",
    transform: "translate(0 0.001)",
    fill: "#8eeff4"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M2.53,0h4.6V-11.27h4.922c8.372,0,12.558-3.128,12.558-9.706,0-6.44-4.048-9.568-12.42-9.568H2.53Zm4.6-15.18V-26.634h5.06c5.52,0,7.728,1.61,7.728,5.658,0,4.186-2.346,5.8-7.866,5.8ZM41.308.552c7.084,0,12.466-3.588,13.662-11.73H50.094c-.92,5.566-4.278,7.452-8.694,7.452-5.566,0-9.292-4.232-9.292-11.362v-.368c0-7.084,3.772-11.362,9.384-11.362,4.278,0,7.5,1.748,8.51,7.084h4.922C53.59-27.6,48.392-31.1,41.538-31.1c-8.326,0-14.168,6.256-14.168,15.824C27.37-5.75,33.166.552,41.308.552ZM55.2,0h4.738L63.25-8.878H75.21L78.384,0H83.26L72.082-30.544H66.7Zm9.43-12.926,4.646-12.6,4.508,12.6Z",
    transform: "translate(574.026 611.418)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPcaGraphic);
export default __webpack_public_path__ + "static/media/PCA-graphic.5dd89b9b8dd7a804d0d511bcfb23173b.svg";
export { ForwardRef as ReactComponent };